import React, { useEffect, useState } from "react";
import {
  GoogleMap,
  InfoWindow,
  Marker,
  MarkerClusterer
} from "@react-google-maps/api";
import { HyperTrackHome } from "../../../API/HyperTrack/HomePage";
import LinearProgress from "@mui/material/LinearProgress";
import { Link } from "@mui/material";
import WorkHomeLocationModal from "../HyperTrack/WorkHomeLocationModal";

const containerStyle = {
  width: "100%",
  height: "100%",
};

interface MapProps {
  startDate: Date | null;
  endDate: Date | null;
  city: string | null;
  merchant: string | null;
}

const GoogleMapApi: React.FC<MapProps> = ({
  startDate,
  endDate,
  city,
  merchant,
}) => {
  const [data, setData] = useState<any[]>([]);
  const [selectedMarker, setSelectedMarker] = useState<number | null>(null);
  const [mapCenter, setMapCenter] = useState({ lat: 28.7136, lng: 77.1294 });
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);

  useEffect(() => {
    HyperTrackHome.api
      .googleMapsOnDutyRidersHyperTrack(startDate, endDate, merchant, city)
      .then((e) => {
        setData(e);
        if (e.length > 0 && city) {
          const avgLat = e.reduce((sum, item) => sum + item.lat, 0) / e.length;
          const avgLng = e.reduce((sum, item) => sum + item.lng, 0) / e.length;
          setMapCenter({ lat: avgLat, lng: avgLng });
        }
      });
  }, [startDate, endDate, merchant, city]);

  const getCustomMarkerIcon = () => {
    
    return {
      url: "https://miro.medium.com/v2/resize:fit:786/format:webp/1*nZ9VwHTLxAfNCuCjYAkajg.png",
      scaledSize: new window.google.maps.Size(5.5, 5.5),
    };
  };

  const [workHomeLocationData, setWorkHomeLocationData] = useState<any | null>(
    null
  );

  const fetchData = async (cycleId: number) => {
    HyperTrackHome.api.workHomeLocation(cycleId, endDate).then((e) => {
      setWorkHomeLocationData(e);
    });
  };

  const handleMarkerClick = (index: number) => {
    setSelectedMarker(index);
  };
  const handleQrCodeClick = (index: number) => {
    const cycleId = data[index]?.cycleId;
    if (cycleId) {
      fetchData(cycleId);
      handleOpen();
    }
  };
  const handleClose = () => {
    setOpen(false);
    // Additional cleanup or logic on modal close if needed
  };
  return (
    <>
      {data ? (
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={mapCenter}
          zoom={12}
        >
          <MarkerClusterer averageCenter enableRetinaIcons gridSize={60} >
  {(clusterer) => (
    <>
          {data.map((item, index) => (
            <Marker
              key={index}
              position={{
                lat: parseFloat(item.lat),
                lng: parseFloat(item.lng),
              }}
              icon={getCustomMarkerIcon()}             
              onMouseOver={() => handleMarkerClick(index)}
              clusterer={clusterer}

            />
          ))}
           </>
  )}
</MarkerClusterer>

          {selectedMarker !== null && (
            <>
              <InfoWindow
                position={{
                  lat: parseFloat(data[selectedMarker].lat),
                  lng: parseFloat(data[selectedMarker].lng),
                }}
                onCloseClick={() => setSelectedMarker(null)}
              >
                <div>
                  <p className="font-bold">
                    <Link
                      style={{ cursor: "pointer" }}
                      onClick={() => handleQrCodeClick(selectedMarker)}
                    >
                      <b>{data[selectedMarker].qrCode}</b>
                    </Link>
                  </p>
                </div>
              </InfoWindow>
              {workHomeLocationData && (
                <WorkHomeLocationModal
                  modalOpen={open}
                  work_latit={workHomeLocationData.work_lat}
                  work_lngit={workHomeLocationData.work_lng}
                  home_latit={workHomeLocationData.home_lat}
                  home_lngit={workHomeLocationData.home_lng}
                  userId={workHomeLocationData.userId}
                  date={endDate}
                  cycleId={data[selectedMarker].cycleId}
                  onClose={handleClose} // Pass onClose function as a prop
                />
              )}
            </>
          )}
        </GoogleMap>
      ) : (
        <div className="w-full">
          <LinearProgress
            sx={{
              backgroundColor: "white",
              "& .MuiLinearProgress-bar": {
                backgroundColor: "#00CD5B",
              },
            }}
          />
        </div>
      )}
    </>
  );
};

export default GoogleMapApi;
